import { useQuery } from "@tanstack/react-query"
import { useApi } from "../../../../hooks/useApi"
import { IAccountBookPairs } from "../../types"

const useTradingDataQuery = ({
  accountBookPairs,
  liveOrders,
  enabled,
  withPnl = true,
  useAccountCurrency = false,
}: {
  accountBookPairs: IAccountBookPairs
  liveOrders: boolean
  enabled: boolean
  withPnl?: boolean
  useAccountCurrency?: boolean
}) => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery(
    ["tradingdatascient", accountBookPairs, liveOrders, withPnl, useAccountCurrency],
    () => scientApi.trading.getTradingData({ accountBookPairs, liveOrders, withPnl, useAccountCurrency }),
    {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      enabled,
    },
  )

  return {
    tradingData: data,
    isLoading,
    error,
  }
}

export default useTradingDataQuery
